<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Kasa Raporu</h1>
      <div class="SayfaBtn el-button-group" v-if="Liste">
        <el-button size="small" type="default" @click="Yazdir" :disabled="lo">Yazdır</el-button>
        <el-button size="small" type="default" @click="Indir" :disabled="lo">İndir</el-button>
      </div>
    </div>
    <div class="SayfaIcerik" v-loading="lo">
      <div class="yazdirtable" v-if="Liste">
        <h1>{{ SayfaAdi }}</h1>
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>No.</th>
            <th>Tarih</th>
            <th>Cari</th>
            <th>Açıklama</th>
            <th class="text-right">Gelir</th>
            <th class="text-right">Gider</th>
            <th class="text-right">Bakiye</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="t in Liste">
            <td>{{ t.id }}</td>
            <td>{{ t.tarih }}</td>
            <td>{{ t.Unvan }}</td>
            <td>{{ t.Aciklama }}</td>
            <td class="text-right">{{ t.Gelir }}</td>
            <td class="text-right">{{ t.Gider }}</td>
            <td class="text-right">{{ t.Bakiye }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="4"></th>
            <th class="text-right">{{ AltToplam.Gelir }}</th>
            <th class="text-right">{{ AltToplam.Gider }}</th>
            <th class="text-right">{{ AltToplam.Bakiye }}</th>
          </tr>
          </tfoot>
        </table>

      </div>
      <el-row>

        <el-col :span="19" class="pr-10">
          <el-alert
              v-if="!Liste"
              title="Filtreleme Yapınız"
              type="info"
              :closable="false"
              description="Verilere erişebilemek için lütfen filtreleme yapınız"
          >
          </el-alert>
          <el-table
              v-if="Liste"
              :data="Liste"
              class="table-xs table-hover yazdirma"
              :height="Height"
              show-summary
              :summary-method="TableFooter">
            <el-table-column label="No." prop="id" width="50"></el-table-column>
            <el-table-column label="Tarih" prop="tarih" width="100"></el-table-column>
            <el-table-column label="Cari" prop="Unvan" width="200"></el-table-column>
            <el-table-column label="Açıklama" prop="Aciklama"></el-table-column>
            <el-table-column label="Gelir" prop="Gelir" width="100" align="right"></el-table-column>
            <el-table-column label="Gider" prop="Gider" width="100" align="right"></el-table-column>
            <el-table-column label="Bakiye" prop="Bakiye" width="100" align="right"></el-table-column>
          </el-table>

        </el-col>
        <el-col :span="5" class="yazdirma">
          <div class="RaporOlay">
            <h1>Filtreleme</h1>
            <el-form :rules="FormHata" :model="Form"
                     @submit.prevent.native="Getir"
                     ref="RaporForm">
              <el-form-item prop="Proje_id" v-if="this.Projeler.length>1">
                <el-select v-model="Form.Proje_id" placeholder="Proje Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Projeler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Grup_id">
                <el-select v-model="Form.Grup_id" placeholder="Grup Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Gruplar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Hizmet_id">
                <el-select v-model="Form.Hizmet_id" placeholder="Hizmet Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Hizmetler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Tarih">
                <el-date-picker
                    :clearable="false"
                    v-model="Form.Tarih"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Başlangıç Tarihi"
                    end-placeholder="Bitiş Tarihi"
                    format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="text-center" prop="Tur">
                <el-radio-group v-model="Form.Tur" size="small">
                  <el-radio-button label="1">Gelir</el-radio-button>
                  <el-radio-button label="0">Gider</el-radio-button>
                  <el-radio-button label="2">Tümü</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-form>
          </div>

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
export default {
  data() {
    return {
      Height: null,
      lo: false,
      AltToplam: null,
      SayfaAdi: 'Kasa Raporu',
      Liste: null,
      Projeler: null,
      Gruplar: null,
      Hizmetler: null,
      ExcelData: null,
      Form: {
        Tur: "2",
        Tarih: [],
        Proje_id: null,
        Grup_id: null
      },
      FormHata: {
        Tarih: [{required: true, message: "Tarih seçiniz", trigger: 'blur'}],
      },
    }
  },
  methods: {

    Indir(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 5},
        {wch: 12},
        {wch: 20},
        {wch: 50},
        {wch: 12},
        {wch: 12},
        {wch: 12},
      ];

      wb.Props = {
        Title: this.SayfaAdi,
        Author: "MUDU APP",
        Manager: "MUDU APP",
        Company: "MUDU",
        Category: "Finans",
        Keywords: "Mudu",
        Comments: this.SayfaAdi,
      };

      XLSX.utils.book_append_sheet(wb, ws, this.SayfaAdi);
      XLSX.writeFile(wb, this.SayfaAdi + ".xlsx");
    },
    Getir() {
      this.lo = true
      this.$store.dispatch("Post", {...this.Form, path: 'rapor/kasa'})
          .then(response => {
            if (response.Durum === "OK") {
              this.lo = false
              this.Liste = response.Data
              this.ExcelData = response.ExcelData
              this.AltToplam = response.AltToplam
            } else {
              this.lo = false
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
            }
          })
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.SayfaAdi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.SayfaAdi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },

    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'grup'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Gruplar = response.Liste
            }
          })
      this.$store.dispatch("Get", {path: 'hizmet'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Hizmetler = response.Liste
            }
          })
    },
    TableFooter() {
      const sums = [];
      sums[4] = this.AltToplam.Gelir;
      sums[5] = this.AltToplam.Gider;
      sums[6] = this.AltToplam.Bakiye;
      return sums;
    },
  },
  created() {

    this.SayfaYukle()
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Projeler = this.$store.state.Proje
    this.Form.Proje_id = this.$store.state.Proje_id

    this.Height = window.innerHeight - 111
    this.$store.dispatch("title", "Kasa Raporu");

  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Raporlama/KasaRaporu.vue